module.exports = __webpack_public_path__ + "img/iconAggregateTruck.b65da818.svg";